import { render } from "./PartPhoto.vue?vue&type=template&id=4edec089&scoped=true"
import script from "./PartPhoto.vue?vue&type=script&lang=js"
export * from "./PartPhoto.vue?vue&type=script&lang=js"

import "./PartPhoto.vue?vue&type=style&index=0&id=4edec089&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edec089"]])

export default __exports__